var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space flex-grow-1"},[_c('div',{class:['bar', _vm.isPass && 'passed' , !_vm.$vuetify.rtl && 'ltr' ]})])}
var staticRenderFns = []

export { render, staticRenderFns }